import { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Stack,
  Collapse,
  IconButton,
} from "@mui/material";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";

const COLORS = {
  bg: "#ffffff",
  text: "#111111",
  muted: "rgba(17,17,17,0.72)",
  line: "rgba(17,17,17,0.08)",
  red: "#e50914",
};

export default function TrainingFAQ() {
  const [open, setOpen] = useState(null);

  const toggle = (id) => {
    setOpen(open === id ? null : id);
  };

  const faqs = [
    {
      id: 1,
      question: "¿Cuántas veces a la semana debería entrenar si estoy empezando?",
      answer:
        "Cuando empiezas, lo más importante no es entrenar todos los días sino crear constancia. Entrenar entre 3 y 4 días por semana suele ser suficiente para comenzar a progresar. Tu cuerpo necesita adaptarse al esfuerzo, aprender los movimientos y recuperarse correctamente. Con el tiempo podrás aumentar intensidad o volumen, pero primero construye el hábito.",
    },
    {
      id: 2,
      question: "¿Es normal sentir dolor muscular después de entrenar?",
      answer:
        "Sí, es algo normal cuando el cuerpo se adapta a un nuevo estímulo. Ese cansancio muscular indica que los músculos están trabajando y adaptándose. Lo importante es mantener buena técnica, descansar bien y seguir entrenando con regularidad. Con el tiempo tu cuerpo se adapta y esa sensación disminuye mientras sigues progresando.",
    },
    {
      id: 3,
      question: "¿Cómo sé si realmente estoy progresando en el gimnasio?",
      answer:
        "El progreso no solo significa levantar más peso. También se refleja en mejor técnica, mayor control del movimiento, más repeticiones con el mismo peso o más resistencia durante el entrenamiento. Llevar registro de tus ejercicios, pesos y repeticiones te permite entender mejor tu avance.",
    },
    {
      id: 4,
      question: "¿La alimentación influye en los resultados del entrenamiento?",
      answer:
        "Mucho más de lo que muchos imaginan. El entrenamiento es el estímulo, pero la alimentación es lo que permite que el cuerpo se recupere y mejore. Consumir suficiente proteína, energía y mantener una alimentación equilibrada ayuda a desarrollar músculo, recuperarte mejor y mantener buen rendimiento.",
    },
    {
      id: 5,
      question: "¿Por qué a veces dejo de aumentar peso en los ejercicios?",
      answer:
        "El progreso no siempre es lineal. A medida que mejoras, avanzar requiere más paciencia y estrategia. A veces necesitas mejorar la técnica, descansar mejor o ajustar tu rutina. Los estancamientos son parte normal del proceso cuando entrenas con constancia.",
    },
    {
      id: 6,
      question: "¿Qué es más importante: levantar más peso o ejecutar bien el ejercicio?",
      answer:
        "La técnica siempre es lo primero. Levantar más peso con mala ejecución aumenta el riesgo de lesión y reduce el estímulo correcto en el músculo. Cuando dominas el movimiento y tienes buen control, entonces aumentar peso se vuelve una herramienta para seguir progresando de forma segura.",
    },
  ];

  return (
    <Box sx={{ bgcolor: COLORS.bg, py: { xs: 6, md: 10 } }}>
      <Container
        maxWidth={false}
        sx={{
          width: { xs: "90%", md: "82%" },
          px: 0,
        }}
      >
        <Stack spacing={1.5} sx={{ mb: { xs: 3, md: 4 }, alignItems: "center" }}>
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: 30, md: 50 },
              lineHeight: 0.9,
              fontWeight: 800,
              letterSpacing: -1,
              textAlign: "center",
            }}
          >
            <Box component="span" sx={{ color: COLORS.text }}>
              Preguntas
            </Box>{" "}
            <Box component="span" sx={{ color: COLORS.red }}>
              frecuentes
            </Box>
          </Typography>
        </Stack>

        <Stack spacing={1.2}>
          {faqs.map((faq) => {
            const isOpen = open === faq.id;

            return (
              <Box
                key={faq.id}
                sx={{
                  borderRadius: 4,
                  border: `1px solid ${COLORS.line}`,
                  overflow: "hidden",
                  bgcolor: "#ffffff",
                }}
              >
                <Box
                  onClick={() => toggle(faq.id)}
                  sx={{
                    p: { xs: 2, md: 2.4 },
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 2,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: 16, md: 19 },
                      fontWeight: 700,
                      color: COLORS.text,
                      lineHeight: 1.25,
                    }}
                  >
                    {faq.question}
                  </Typography>

                  <IconButton
                    sx={{
                      color: COLORS.text,
                      transition: "transform 0.25s ease",
                    }}
                  >
                    <KeyboardArrowDownRoundedIcon
                      sx={{
                        transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.25s ease",
                      }}
                    />
                  </IconButton>
                </Box>

                <Collapse in={isOpen}>
                  <Box
                    sx={{
                      px: { xs: 2, md: 2.4 },
                      pb: { xs: 2.2, md: 2.6 },
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { xs: 14.5, md: 15.5 },
                        lineHeight: 1.75,
                        color: COLORS.muted,
                        fontWeight: 600,
                      }}
                    >
                      {faq.answer}
                    </Typography>
                  </Box>
                </Collapse>
              </Box>
            );
          })}
        </Stack>
      </Container>
    </Box>
  );
}